/** Environment Types */
export interface Environment {
  id: string;
  name: string;
  description?: string;
  hintText?: string;
  icon?: string;
  category?: string;
  isEnabled?: boolean;
}

export const ENVIRONMENTS: Environment[] = [
  {
    id: 'mr-managed',
    name: 'MetaRouter Managed',
    description: 'Fully managed MetaRouter infrastructure',
    hintText: 'Best for most use cases',
    icon: 'cloud',
    category: 'managed',
    isEnabled: true
  },
  {
    id: 'vpc',
    name: 'Private cloud deployment',
    description: 'Private cloud deployment',
    hintText: 'For enhanced security and compliance',
    icon: 'shield',
    category: 'private',
    isEnabled: true
  },
  {
    id: 'aws',
    name: 'Amazon Web Services',
    description: 'Amazon Web Services',
    icon: 'aws',
    category: 'cloud',
    isEnabled: true
  },
  {
    id: 'gcp',
    name: 'Google Cloud Platform',
    description: 'Google Cloud Platform',
    icon: 'gcp',
    category: 'cloud',
    isEnabled: true
  },
  {
    id: 'azure',
    name: 'Microsoft Azure',
    description: 'Microsoft Azure',
    icon: 'azure',
    category: 'cloud',
    isEnabled: true
  },
  {
    id: 'closed',
    name: 'Closed Environment',
    description: 'Closed environment',
    icon: 'lock',
    category: 'special',
    isEnabled: true
  },
  {
    id: 'other',
    name: 'Other',
    description: 'Custom environment',
    icon: 'custom',
    category: 'special',
    isEnabled: false
  }
];

/** Module Types */
export interface Module {
  id: string;
  name: string;
  description?: string;
  category?: string;
  icon?: string;
  isEnabled?: boolean;
  requiresEnterprise?: boolean;
  compatibleEnvironments?: string[];
}

export const MODULES: Module[] = [
  {
    id: 'consent-enforcement',
    name: 'Consent Enforcement',
    description: 'Enforce user consent preferences',
    category: 'privacy',
    icon: 'shield-check',
    isEnabled: true
  },
  {
    id: 'bot-detection',
    name: 'Bot Detection',
    description: 'Identify and filter bot traffic',
    category: 'security',
    icon: 'robot',
    isEnabled: true
  },
  {
    id: 'data-replay',
    name: 'Data Replay',
    description: 'Replay historical data',
    category: 'data',
    icon: 'refresh',
    isEnabled: true,
    requiresEnterprise: true
  },
  {
    id: 'schema-enforcement',
    name: 'Schema Enforcement',
    description: 'Validate data against schemas',
    category: 'data',
    icon: 'check-square',
    isEnabled: true
  },
  {
    id: 'transformations',
    name: 'Transformations',
    description: 'Transform data in transit',
    category: 'data',
    icon: 'transform',
    isEnabled: true
  }
];

export type EnvironmentId = string;
export type ModuleId = string;

export interface ClusterEnvironmentConfig {
  environmentId: EnvironmentId;
  name: string;
  hintText?: string;
}

export interface ModuleConfig {
  moduleId: ModuleId;
  enabled: boolean;
}
